module.exports = __webpack_public_path__ + "static/media/onethousandappearances.06589312.jpg";